import React from "react";
import { LoadScript } from "@react-google-maps/api";
import Home from "./Home";

const HomeWithMap = () => {
const GOOGLE_MAPS_API_KEY = "AIzaSyDxpKBuxXpQRXU3XL97I4qqf2dbE_5M7Z0";

  return (
    <LoadScript
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      libraries={["places"]} 
    >
      <Home apiKey={GOOGLE_MAPS_API_KEY} />
    </LoadScript>
  );
};

export default HomeWithMap;
